export default __webpack_public_path__ + "static/media/12@3x.bd3f0f1d.png";